import React from 'react';
import Sticky from 'react-sticky-el';
import { Link } from "react-router-dom";
import { auth, db, functions } from '../firebase'
import $ from 'jquery';
import { MyContext } from '../context';
import { Menu } from '../components'
export default class Header extends React.Component {
  constructor() {
    super();
    this.state = {
      selectedMenu: 0,
      menu: 0,
      showNotification: false
    };
  }
  clickEvent(e) {
    let item = $(e.target);
    this.setState({
      menu: 0
    })
  }
  componentDidMount() {
    // Animated Notification Icon
    setInterval(function () {
      $('#m_topbar_notification_icon .m-nav__link-icon').addClass('m-animate-shake');
      $('#m_topbar_notification_icon .m-nav__link-badge').addClass('m-animate-blink');
    }, 3000);

    setInterval(function () {
      $('#m_topbar_notification_icon .m-nav__link-icon').removeClass('m-animate-shake');
      $('#m_topbar_notification_icon .m-nav__link-badge').removeClass('m-animate-blink');
    }, 6000);
    var lastScrollTop = 0;
    $(window).scroll(function (e) {
      var st = $(this).scrollTop();
      if (st > lastScrollTop) {
        $("body").removeClass("m-header--minimize-off");
        $("body").addClass("m-header--minimize-on");
      } else {
        $("body").addClass("m-header--minimize-off");
        $("body").removeClass("m-header--minimize-on")
      }
      lastScrollTop = st;
    });
  }
  showNotification = (e) => {
    $("#showNotification").toggleClass("m-dropdown--open");
    $("#dropmenu").removeClass("m-dropdown--open");
  }
  dropmenu = (e) => {
    $("#showNotification").removeClass("m-dropdown--open");
    $("#dropmenu").toggleClass("m-dropdown--open");
  }
  notifications() {

  }

  listItem(item) {
    const time = new Date(item.createdTimestamp);
    return (
      <div className="m-list-timeline__item" onClick={this.showNotification} key={item.key} >
        <span className="m-list-timeline__badge -m-list-timeline__badge--state-success"></span>
        <Link to={item.to} className="m-list-timeline__text">{item.title}</Link>
        <span className="m-list-timeline__time">{this.monthNames[time.getMonth()] + " " + time.getDate()}</span>
      </div>
    )
  }
  monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];
  render() {
    const route = window.location.pathname;
    return (
      <MyContext.Consumer>
        {state => {
          let count = 0;
          let notification = <React.Fragment>
            {
              state.notification && state.notification.map(item => {
                if (!item.read) {
                  count++;
                }
                return this.listItem(item);
              })
            }
          </React.Fragment>
          return (<header className="m-grid__item		m-header " data-minimize="minimize" data-minimize-offset="200" data-minimize-mobile-offset="200">
            <div className="m-header__top">
              <div className="m-container m-container--responsive m-container--xxl m-container--full-height m-page__container">
                <div className="m-stack m-stack--ver m-stack--desktop">
                  <div className="m-stack__item m-brand">
                    <div className="m-stack m-stack--ver m-stack--general m-stack--inline">
                      <div className="m-stack__item m-stack__item--middle m-brand__logo">
                        <Link to="/" className="m-brand__logo-wrapper">
                          <img alt="" src="/assets/app/media/img/logos/logo.png" />
                        </Link>
                      </div>
                      <div className="m-stack__item m-stack__item--middle m-brand__tools">
                        <div className="m-dropdown m-dropdown--inline">
                          <a className="dropdown-toggle btn   m-btn--pill no-arrow" onClick={e => {
                            // let data = {
                            //   token: state.config.token,
                            //   title: "Test Notification",
                            //   body: "This is test notification"
                            // }
                            // functions.sendNotification(data)
                            //   .then(result => {
                            //     console.log(result);
                            //   })
                            //   .catch(error => {
                            //     console.log(error);
                            //   });
                          }}>
                            <span>Welcome Admin</span>
                          </a>
                        </div>
                        <a id="m_aside_header_menu_mobile_toggle" className="btn m-brand__icon m-brand__toggler m--visible-tablet-and-mobile-inline-block">
                          <span></span>
                        </a>
                        <a id="m_aside_header_topbar_mobile_toggle" className="btn m-brand__icon m--visible-tablet-and-mobile-inline-block">
                          <i className="flaticon-more"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="m-stack__item m-stack__item--fluid m-header-head" id="m_header_nav">
                    <div id="m_header_topbar" className="m-topbar  m-stack m-stack--ver m-stack--general">
                      <div className="m-stack__item m-topbar__nav-wrapper">
                        <ul className="m-topbar__nav m-nav m-nav--inline">
                          <li id="showNotification" className="m-nav__item m-topbar__notifications m-topbar__notifications--img m-dropdown m-dropdown--large m-dropdown--header-bg-fill m-dropdown--arrow m-dropdown--align-center m-dropdown--mobile-full-width"
                            data-dropdown-toggle="click" data-dropdown-persistent="true">
                            <a className="btn m-nav__link m-dropdown__toggle" id="m_topbar_notification_icon"
                              onClick={this.showNotification}>
                              <span className="m-nav__link-badge m-badge m-badge--dot m-badge--dot-small m-badge--danger"></span>
                              <span className="m-nav__link-icon">
                                <span className="m-nav__link-icon-wrapper">
                                  <i className="flaticon-music-2"></i>
                                </span>
                              </span>
                            </a>
                            <div className="m-dropdown__wrapper">
                              <span className="m-dropdown__arrow m-dropdown__arrow--center"></span>
                              <div className="m-dropdown__inner">
                                <div className="m-dropdown__header m--align-center" style={{ background: "url(assets/app/media/img/misc/notification_bg.jpg)", backgroundSize: "cover" }}>
                                  <span className="m-dropdown__header-title" style={{ color:'black'}}>{count > 0 ? count : "No"} New Notifications</span>
                                  {/* <span className="m-dropdown__header-subtitle">User Notifications</span> */}
                                </div>
                                <div className="m-dropdown__body">
                                  <div className="m-dropdown__content">
                                    <div className="tab-content">
                                      <div className="tab-pane active" id="topbar_notifications_notifications" role="tabpanel">
                                        <div className="m-scrollable" data-scrollable="true" data-max-height="250" data-mobile-max-height="200">
                                          <div className="m-list-timeline m-list-timeline--skin-light">
                                            <div className="m-list-timeline__items">
                                              {notification}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </li>
                          <li id="dropmenu" className="m-nav__item m-topbar__user-profile m-topbar__user-profile--img  m-dropdown m-dropdown--medium m-dropdown--arrow m-dropdown--header-bg-fill m-dropdown--align-right m-dropdown--mobile-full-width m-dropdown--skin-light" data-dropdown-toggle="click">
                            <a className="m-nav__link m-dropdown__toggle btn" onClick={this.dropmenu}>
                              <span className="m-topbar__welcome">Hello, &nbsp;</span>
                              <span className="m-topbar__username">
                                {'Admin'}
                              </span>
                            </a>
                            <div className="m-dropdown__wrapper">
                              <span className="m-dropdown__arrow m-dropdown__arrow--right m-dropdown__arrow--adjust" style={{ left: "auto", right: "50.5px" }}></span>
                              <div className="m-dropdown__inner">
                                {/* <div className="m-dropdown__header m--align-center" style={{ background: "url(assets/app/media/img/misc/user_profile_bg.jpg)", backgroundSize: "cover" }}>
                                  <div className="m-card-user m-card-user--skin-dark">
                                    <div className="m-card-user__pic">
                                      <img src="assets/app/media/img/users/user4.jpg"
                                        className="m--img-rounded m--marginless" alt="" />
                                    </div>
                                  </div>
                                </div> */}
                                <div className="m-dropdown__body">
                                  <div className="m-dropdown__content">
                                    <ul className="m-nav m-nav--skin-light">
                                      <li className="m-nav__item">
                                        <Link to="/" className="m-nav__link">
                                          <i className="m-nav__link-icon flaticon-info"></i>
                                          <span className="m-nav__link-text">FAQ</span>
                                        </Link>
                                      </li>
                                      <li className="m-nav__item">
                                        <Link to="/" className="m-nav__link">
                                          <i className="m-nav__link-icon flaticon-lifebuoy"></i>
                                          <span className="m-nav__link-text">Support</span>
                                        </Link>
                                      </li>
                                      <li className="m-nav__separator m-nav__separator--fit"></li>
                                      <li className="m-nav__item">
                                        <a className="btn m-btn--pill btn-secondary m-btn m-btn--custom m-btn--label-brand m-btn--bolder"
                                          onClick={e => {
                                            auth.doSignOut()
                                          }}>Logout</a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="m-header__bottom">
              <div className="m-container m-container--responsive m-container--xxl m-container--full-height m-page__container">
                <div className="m-stack m-stack--ver m-stack--desktop">
                  <div className="m-stack__item m-stack__item--middle m-stack__item--fluid">
                    <button className="m-aside-header-menu-mobile-close  m-aside-header-menu-mobile-close--skin-light " id="m_aside_header_menu_mobile_close_btn">
                      <i className="la la-close"></i>
                    </button>
                    <div id="m_header_menu" className="m-header-menu m-aside-header-menu-mobile m-aside-header-menu-mobile--offcanvas  m-header-menu--skin-dark m-header-menu--submenu-skin-light m-aside-header-menu-mobile--skin-light m-aside-header-menu-mobile--submenu-skin-light ">
                      <ul className="m-menu__nav  m-menu__nav--submenu-arrow ">
                        <Menu path="/" title="Dashboard" />
                        <Menu path="/drivers" title="Drivers" />
                        <Menu path="/users" title="Users" />
                        <Menu path="/trips" title="Trips" />
                        <Menu path="/vehicles" title="Vehicle Types" />
                        <Menu path="/maps" title="Map View" />
                        <Menu path="/withdraw" title="Withdraw Request" />
                      </ul>
                    </div>
                  </div>
                  <div className="m-stack__item m-stack__item--middle m-dropdown m-dropdown--arrow m-dropdown--large m-dropdown--mobile-full-width m-dropdown--align-right m-dropdown--skin-light m-header-search m-header-search--expandable m-header-search--skin-" id="m_quicksearch" data-search-type="default">
                    <form className="m-header-search__form">
                      <div className="m-header-search__wrapper">
                        <span className="m-header-search__icon-search" id="m_quicksearch_search">
                          <i className="la la-search"></i>
                        </span>
                        <span className="m-header-search__input-wrapper">
                          <input autoComplete="off" type="text" name="q" className="m-header-search__input" placeholder="Search..." id="m_quicksearch_input" />
                        </span>
                        <span className="m-header-search__icon-close" id="m_quicksearch_close">
                          <i className="la la-remove"></i>
                        </span>
                        <span className="m-header-search__icon-cancel" id="m_quicksearch_cancel">
                          <i className="la la-remove"></i>
                        </span>
                      </div>
                    </form>
                    <div className="m-dropdown__wrapper">
                      <div className="m-dropdown__arrow m-dropdown__arrow--center"></div>
                      <div className="m-dropdown__inner">
                        <div className="m-dropdown__body">
                          <div className="m-dropdown__scrollable m-scrollable" data-max-height="300" data-mobile-max-height="200">
                            <div className="m-dropdown__content m-list-search m-list-search--skin-light"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </header >
          )
        }}
      </MyContext.Consumer>)
  }
}


// WEBPACK FOOTER //
// ./src/include/Header.js